import React from "react";
import { useSelector } from 'react-redux';
import { Steps as PrimeSteps} from 'primereact/steps';
import { checkPermissions } from "../utils";


function Steps(props){
    const userDetails = useSelector(state => state.userDetails)

    let stepsItems = props.model
    let activeIndex = props.activeIndex || props.activeIndex === 0 ? props.activeIndex : ''
    let readOnly = props.readOnly ? props.readOnly: false
    
    const permParams = {
        activeCompanyRoleId: userDetails.activeCompanyRoleId,
        userRoleId: userDetails.activeRoleId,
        permExceptions: userDetails.permExceptions,
        permGeo: userDetails.permGeo,
        permActions: userDetails.permActions,
        permRoles: userDetails.permRoles
    }

    // stepsItems = stepsItems.map(eachItems => ({...eachItems}))

    stepsItems = stepsItems.map(eachItem => {
        if(eachItem.permissions?.length){
            const {isPermitted} = checkPermissions({...permParams, reqPermActionIds: eachItem.permissions})
            eachItem.disabled = eachItem.disabled || !isPermitted ? true : false
        }
        return eachItem
    })

    const handleOnStepChange = (e) => {
        if(props.onSelect){
            props.onSelect(e.index)
        }
    }

    return(
        <>
            <PrimeSteps model={stepsItems} activeIndex={activeIndex} onSelect={(e) => handleOnStepChange(e.index)} readOnly={readOnly} />
        </>
    )
}

export default Steps;